function isSpecialInput(input) {
    return input.type === 'date' ||
           input.classList.contains('js-inputMasketDate') ||
           input.dataset.intlTelInputId !== undefined;
}

function handleFocus(input, inputGroup, infieldInputGroup) {
    inputGroup.classList.add("is-focus");
    if (infieldInputGroup) {
        infieldInputGroup.classList.add("is-focus");
    }
}

function handleBlur(input, inputGroup, infieldInputGroup) {
    inputGroup.classList.remove("is-focus");
    if (infieldInputGroup) {
        infieldInputGroup.classList.remove("is-focus");
    }
}

function handleInput(input) {
    console.log(111);
}

export function focusInputGroups(query = document.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea')) {
    for (const input of query) {
        const inputGroup = input.closest(".inputGroup");
        const infieldInputGroup = input.closest(".infieldInputGroup");

        /*
        input.addEventListener("focus", () => handleFocus(input, inputGroup, infieldInputGroup));
        input.addEventListener("blur", () => handleBlur(input, inputGroup, infieldInputGroup));
        input.addEventListener("input", () => handleInput(input));*/
    }
}

export function checkFilledInput(input) {
    const inputGroup = input.closest(".inputGroup");
    const infieldInputGroup = input.closest(".infieldInputGroup");

    function updateInputClasses() {
        let hasValue;
        try {
            hasValue = input.matches(':autofill');
        } catch (err) {
            try {
                hasValue = input.matches(':-webkit-autofill');
            } catch (er) {
                hasValue = false;
            }
        }
        const isFilled = input.value !== "" || hasValue;

        const specialInput = isSpecialInput(input);

        if (inputGroup) {
            if (specialInput) {
                inputGroup.classList.add("is-filled");
            } else {
                if (isFilled) {
                    inputGroup.classList.add("is-filled");
                } else {
                    inputGroup.classList.remove("is-filled");
                }
            }
        }

        if (infieldInputGroup) {
            if (specialInput) {
                infieldInputGroup.classList.add("is-filled");
            } else {
                if (isFilled) {
                    infieldInputGroup.classList.add("is-filled");
                } else {
                    infieldInputGroup.classList.remove("is-filled");
                }
            }
        }
    }

    updateInputClasses();
    const observer = new MutationObserver(updateInputClasses);
    observer.observe(input, { attributes: true, attributeFilter: ['class', 'autofill'] });

    const intervalId = setInterval(updateInputClasses, 200);

    input.addEventListener('focus', updateInputClasses);

    setTimeout(() => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    }, 5000);

    return () => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    };
}